import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Sidebar from "../../SideComponents/BlogsSidebar";
import Styles from "../../../assets/css/Blogs/ProblemSolving/SecuritySolutions.module.css";
import debounce from "lodash.debounce"; // lodash.debounce , It will Add delay to observer that can help stoping the flickerings
import { Helmet } from "react-helmet-async";

// Global States imports
import { useGlobalState } from "../../../Functions/GlobalStates";

const SecuritySolutions = () => {
  // This Id Will Help Get Likes & Views Of This Problem⬇️
  const questionId = "6"; // Replace with dynamic question ID
  const [likes, setLikes] = useState(0); // State to hold the number of likes
  const [Views, setViews] = useState(0); // State to hold the number of likes
  // Global States
  const { PagesWidthHeight, setPagesWidthHeight } = useGlobalState();
  // React useRef Refferences
  const CheckSecuritySolutionsSize = useRef(false);

  // Fetching images
  // const SecuritySolutionsSolutionImages = require.context(
  //   "../../../assets/images/Blogs/SecuritySolutions", // Path to the directory
  //   false, // Do not include subdirectories (set to true if you want to include them)
  //   /\.(png|PNG|jpg|jpeg|webp|svg)$/ // Regular expression to match file types
  // );
  // const SolutionImages = [
  // SecuritySolutionsSolutionImages("./screen1.png"), // Dynamically load the image
  // SecuritySolutionsSolutionImages("./screen2.png"), // Dynamically load the image
  // SecuritySolutionsSolutionImages("./screen3.png"), // Dynamically load the image
  // SecuritySolutionsSolutionImages("./screen4.png"), // Dynamically load the image
  // SecuritySolutionsSolutionImages("./screen5.png"), // Dynamically load the image
  // ];

  // updating height to modify sidebar height
  useEffect(() => {
    const updateSize = () => {
      const { height } =
        CheckSecuritySolutionsSize.current.getBoundingClientRect();
      setPagesWidthHeight((prev) => ({
        ...prev,
        height: parseFloat(height.toFixed(1)),
      }));
      // console.log("Heigth", height);
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []);

  // Fetch Likes From Database
  useEffect(() => {
    const AllViews = async () => {
      const hasViewed = localStorage.getItem(`viewed_${questionId}`); // Check if user has already viewed this question

      try {
        if (hasViewed) {
          // alert("You have already Viewed this question.");
          // Fetching the current view data
          const ViewsResponse = await axios.get(
            `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
          );
          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            // alert('Thank you for Viewing the question!');
          } else {
            console.error("No view data received from the get req and server");
          }
        } else {
          // Sending PUT request to the server to update or create the view count
          const ViewsResponse = await axios.put(
            `https://affiliators.netlify.app/.netlify/functions/server/api/views/${questionId}`
          );

          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            localStorage.setItem(`viewed_${questionId}`, "true"); // Mark as viewed in localStorage
            // alert("Thank you for Viewing the question!");
          } else {
            console.error("No view data received from the put req and server");
          }
        }
      } catch (error) {
        console.error("Error updating views:", error.message);

        // Check if the error is due to the document not being found
        if (error.response && error.response.status === 404 && !hasViewed) {
          // Retry by invoking GET request to create the data if missing
          try {
            // Retry the GET request only if the user has not viewed yet
            const retryResponse = await axios.get(
              `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
            );
            if (retryResponse.data && retryResponse.data.views !== undefined) {
              setViews(retryResponse.data.views); // Update state with the number of views
              // alert("Thank you for Viewing the question!");
            } else {
              console.error("No view data received from the retry GET request");
            }
          } catch (retryError) {
            console.error("Error on retrying GET request:", retryError.message);
            // alert("Error retrying to fetch view data. Please try again later.");
          }
        } else {
          // alert("Error updating views. Please try again later.");
        }
      }
    };

    AllViews();

    const fetchOrAddLikes = async () => {
      try {
        const fetchresponse = await axios.get(
          `https://affiliators.netlify.app/.netlify/functions/server/api/checklikes/${questionId}`
        ); // Fetch or create likes
        setLikes(fetchresponse.data.likes); // Update state with the number of likes
      } catch (error) {
        console.error("Error fetching or adding likes:", error.message);
      }
    };

    fetchOrAddLikes();
  }, []);

  const HandleLike = async () => {
    const hasLiked = localStorage.getItem(`liked_${questionId}`); // Check if user has liked the question

    if (hasLiked) {
      // alert("You have already liked this question.");
      return;
    }
    try {
      const response = await axios.put(
        `https://affiliators.netlify.app/.netlify/functions/server/api/updatelikes/${questionId}`
      ); // Send request to backend
      setLikes(response.data.likes); // Update the likes state with the latest count

      // Store in localStorage to prevent multiple likes
      localStorage.setItem(`liked_${questionId}`, "true");
      // alert("Thank you for liking the question!");
    } catch (error) {
      console.error("Error updating likes:", error.message);
    }
  };

  const SidebarProps = {
    RTL1: "https://jetpack.com/resources/weak-passwords/",
    RTL2: "https://abnormalsecurity.com/glossary/data-breach",
    RTL3: "https://www.techtarget.com/searchsecurity/tip/10-common-types-of-malware-attacks-and-how-to-prevent-them",
    RTL4: "https://www.suntera.com/our-expert-commentary/the-rise-of-ddos-attacks",
    RTL5: "https://www.checkout.com/blog/best-practices-for-secure-online-payment-processing",
    RTL6: "https://support.microsoft.com/en-us/windows/protect-yourself-from-phishing-0c7ea947-ba98-3bd9-7184-430e1f860a44",
    RTC1: "Weak Passwords",
    RTC2: "Data Breaches",
    RTC3: "Malware Attacks",
    RTC4: "DDoS Threats",
    RTC5: "Secure Payment Processing",
    RTC6: "Phishing Scam Prevention",
  };

  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Online Business Security Risks & Solutions 🔒</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Understand the top security risks in online businesses and learn how to protect your website and customer data effectively."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="online business security, cybersecurity risks, data protection, website security"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Online Business Security Risks & Solutions 🔒"
        />
        <meta
          property="og:description"
          content="Understand the top security risks in online businesses and learn how to protect your website and customer data effectively."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/problemsolving/securitysolutions"
        />
        {/* <meta
          property="og:image"
          content="/images/SecuritySolutions/securitysolutions1.png"
        /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Online Business Security Risks & Solutions 🔒"
        />
        <meta
          name="twitter:description"
          content="Understand the top security risks in online businesses and learn how to protect your website and customer data effectively."
        />
        {/* <meta
          name="twitter:image"
          content="/images/SecuritySolutions/securitysolutions1.png"
        /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/problemsolving/securitysolutions"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div className={Styles.BlogSidebarSecuritySolutionsContainer}>
        <Sidebar {...SidebarProps} />
        <div
          ref={CheckSecuritySolutionsSize}
          className={Styles.SecuritySolutionsContainer}
        >
          <section className={Styles.SecuritySolutionsSection1Container}>
            <div
              className={
                Styles.SecuritySolutionsSection1QuestionLikesViewsContainer
              }
            >
              <h4>Problem</h4>
              <h1>Security Risks in Online Businesses.</h1>
              <div
                className={Styles.SecuritySolutionsSection1LikesViewsContainer}
              >
                <button
                  className={Styles.LikeButton}
                  onClick={HandleLike}
                  aria-label="Like this question"
                >
                  👍🏻 {likes}
                </button>
                <span>{Views} Views</span>
              </div>
            </div>
          </section>
          <section className={Styles.SecuritySolutionsSection2Container}>
            <div className={Styles.SecuritySolutionsSection2AnswerContainer}>
              <h4>Solution</h4>
              <p>Follow These Steps:</p>
              <h3>Step No. 1 ....</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.SecuritySolutionsSection2AnswerVideo1}
                src="https://www.youtube.com/embed/kbpjwL4jawg?si=gRUD9vNLEXlBqVFL"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <p>
                If the following video solved your problem, feel free to skip
                the remaining steps. If not, continue with the next steps ⬇️
              </p>
              <h3>Step 2: Implement Strong Authentication Measures</h3>
              {/* <h3>For Windows Users</h3> */}
              <div
                className={
                  Styles.SecuritySolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>
                    👉🏻 Use multi-factor authentication (MFA) for added security.
                  </p>
                  {/* <img src={SolutionImages[0]} alt="loding step 2" /> */}
                </div>
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>👉🏻 Require strong passwords with regular updates.</p>
                  {/* <img src={SolutionImages[2]} alt="loding step 2" /> */}
                </div>
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>👉🏻 Enable biometric authentication where possible.</p>
                  {/* <img src={SolutionImages[1]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 3: Secure Your Website with HTTPS</h3>
              <div
                className={
                  Styles.SecuritySolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>👉🏻 Install an SSL certificate to encrypt data.</p>

                  <p>👉🏻 Ensure all pages use HTTPS to prevent interception.</p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>👉🏻 Regularly check for SSL vulnerabilities.</p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 4: Regular Security Updates & Patching</h3>
              <div
                className={
                  Styles.SecuritySolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>👉🏻 Keep software, plugins, and CMS updated.</p>

                  <p>👉🏻 Apply security patches as soon as they are released.</p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>👉🏻 Conduct vulnerability scans regularly.</p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 5: Protect Against DDoS & Malware Attacks</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.SecuritySolutionsSection2AnswerVideo1}
                src="https://www.youtube.com/embed/ilhGh9CEIwM?si=mH_WdM35no3nEKMA"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <div
                className={
                  Styles.SecuritySolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>
                    👉🏻 Use a Web Application Firewall (WAF) for filtering
                    traffic.
                  </p>

                  <p>
                    👉🏻 Implement DDoS protection services to prevent attacks.
                  </p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>👉🏻 Run malware scans and remove threats proactively.</p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 6: Secure Payment Processing</h3>
              <div
                className={
                  Styles.SecuritySolutionsSection2AnswerImagesContainer
                }
              >
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>👉🏻 Train employees on phishing & cyber threats.</p>

                  <p>👉🏻 Encourage customers to use secure passwords.</p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={Styles.SecuritySolutionsSection2AnswerImgContainer}
                >
                  <p>👉🏻 Provide guidelines for safe online transactions.</p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <p>
                I hope you found this helpful! 👍✨ Don't forget to rate this
                blog!
              </p>
              <h3>HashTags</h3>
              <p>
                #CyberSecurity #OnlineSafety #DataProtection #SecurePayments
                #ECommerceSecurity #SSL #DDoSProtection #FraudPrevention
                #WebSecurity #SafeTransactions
              </p>
              <h3>Keywords</h3>
              <p>
                website security solutions, protect online store, cybersecurity
                for businesses, secure payment methods, SSL encryption, prevent
                hacking, anti-malware tools, DDoS protection, data privacy
                measures, e-commerce fraud prevention.
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default SecuritySolutions;
